import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { idVietnam } from '../../../../../authentication/postLogin/constant'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Input } from '../../../../../common/html/input'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import Tree from '../../../../../common/tree'
import { keyBy } from '../../../../../helpers/common'
import classes from '../../../../index.module.scss'
import { selectForeign, setForeign } from '../../../store/slice'

const ForeignTree = ({ countries, customContainerStyle }) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectForeign)

  const [countryTree, setCountryTree] = useState({})

  const [valueSearch, setValueSearch] = useState('')

  useEffect(() => {
    if (countries.length) {
      setCountryTree(
        keyBy(
          countries
            .filter((item) => item.id !== idVietnam)
            .map((item) => ({ ...item, children: {} })),
          'code',
        ),
      )
    }
  }, [countries])

  const changeSearch = (e) => setValueSearch(e.target.value)

  const setChecked = (items) => dispatch(setForeign(items))

  const textSearch = UseI18n('settingPreferences.SEARCH_COUNTRY')

  return (
    <>
      <Input
        placeHolder={textSearch}
        containerStyle={{ height: '28px' }}
        value={valueSearch}
        onChange={changeSearch}
        noControl
      />
      <div className={classes.treeContainer} style={customContainerStyle}>
        <ScrollComponent>
          <Tree
            treeData={countryTree}
            idKey="id"
            nameKey="name"
            isHaveCheckbox={true}
            valueSearch={valueSearch}
            listChecked={checked}
            setListChecked={setChecked}
            disabledCheckDbClick={true}
          />
        </ScrollComponent>
      </div>
    </>
  )
}

ForeignTree.propTypes = {
  countries: PropTypes.array.isRequired,
}

export default ForeignTree
